import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d49e482a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = {
  key: 0,
  "data-test": "footer-nav-partner"
}
const _hoisted_3 = {
  href: "https://partner-web.ciaoinc.jp/ciaocamera/index.php",
  target: "_blank"
}
const _hoisted_4 = {
  key: 1,
  "data-test": "footer-nav-admin"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  href: "https://ciao.camera/",
  target: "_blank"
}
const _hoisted_7 = {
  href: "https://www.ciaoinc.jp/contact.html",
  target: "_blank"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "copyright" }, "© 2013 Ciao Inc.", -1))
const _hoisted_9 = { class: "version" }

import { useStore } from 'vuex'
import { computed } from 'vue'
import APP from '@/js/const/app'
import Icon from '@/components/atoms/Icon'


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterNav',
  setup(__props) {

const store = useStore()
const version = APP.APP_VERSION

const permissions = computed(() => store.getters['auth/permissions'])
const settings = computed(() => store.getters['app/settings'])
/**
 * adminSystemUrl 表示
 */
const useAdminSystemUrl = computed<boolean>(
  () => permissions.value.admin && settings.value && settings.value.adminSystemUrl
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", null, [
      _createElementVNode("ul", null, [
        (_unref(permissions).partner)
          ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
              _createElementVNode("a", _hoisted_3, [
                _createVNode(_unref(Icon), {
                  type: "open_in_new",
                  color: "color-dark-2",
                  size: "16"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('footer_nav.partner_site')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(useAdminSystemUrl))
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
              _createElementVNode("a", {
                href: _unref(settings).adminSystemUrl,
                target: "_blank"
              }, [
                _createVNode(_unref(Icon), {
                  type: "open_in_new",
                  color: "color-dark-2",
                  size: "16"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('footer_nav.administration_system')), 1)
              ], 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_6, [
            _createVNode(_unref(Icon), {
              type: "open_in_new",
              color: "color-dark-2",
              size: "16"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('footer_nav.about_ciao_camera')), 1)
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_7, [
            _createVNode(_unref(Icon), {
              type: "open_in_new",
              color: "color-dark-2",
              size: "16"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('footer_nav.contact')), 1)
          ])
        ])
      ]),
      _hoisted_8,
      _createElementVNode("p", _hoisted_9, "Version " + _toDisplayString(_unref(version)), 1)
    ])
  ]))
}
}

})